"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// Do not edit this file, it is automatically generated by @paprika/build-translations
var locales = {
    "pt": {
        "translation": {
            "left_navigation": {
                "loading": "Carregando",
                "hidden_target": "Sua seleção não pode ser exibida devido ao(s) filtro(s) aplicado(s). Para exibir o item, remova o(s) filtro(s) adequado(s).",
                "sidenav_open": "Abrir navegação",
                "sidenav_close": "Fechar navegação",
                "expand": "Expandir",
                "collapse": "Ocultar",
                "small_search": "Digite pelo menos 2 caracteres para pesquisar.",
                "no_search_results": "Nenhum resultado de pesquisa encontrado.",
                "filter_search": "Filtrar...",
                "collection_archive": "Arquivo da coleção",
                "activities": {
                    "title": "Atividade",
                    "details": "Detalhes",
                    "reset": "Reiniciar",
                    "load_more": "Carregar mais",
                    "no_results": "Não há atividades para o filtro especificado.",
                    "no_more_results": "Você chegou ao final das atividades para o filtro especificado.",
                    "actions": {
                        "created": "Criado(a) em",
                        "deleted": "Excluído(a)",
                        "updated": "Atualizado(a)"
                    }
                },
                "settings": {
                    "title": "Configurações"
                }
            }
        }
    }
};
exports.default = locales;
//# sourceMappingURL=pt.js.map